<template>
  <v-dialog
    v-model="showDialogInvoiceFulfillment"
    width="400"
    transition="scroll-y-reverse-transition"
  >
    <v-card>
      <v-card-title class="blue darken-2 white--text">
        <h2 class="text-h4 mb-1">
          Fulfillment Details
        </h2>
      </v-card-title>

      <v-card-text class="pt-6 pb-8">
        <AirtableHtml
          v-if="getShopDetail('Fulfillment Instructions', '').length"
          setting-name="Fulfillment Instructions"
          tag-class="text-subtitle-1"
        />
        <h2 v-else class="text-h6"
          >Our shop doesn't have any specific instructions for you.<br /><br />
          Thanks for shopping with us.</h2
        >
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="showDialogInvoiceFulfillment = false"
          block
          outlined
          color="grey darken-3 white--text"
          >Close</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import AirtableHtml from '@/components/AirtableHtml'

export default {
  name: 'DialogInvoiceFulfillment',
  components: { AirtableHtml },
  computed: {
    ...mapFields('order', ['showDialogInvoiceFulfillment']),
    ...mapGetters('shop', ['getShopDetail']),
  },
  data() {
    return {}
  },
}
</script>
